module.exports = __webpack_public_path__ + "static/media/tooltip.79327e8e.svg";